'use strict';

export default {
  copy: 'Carelon Wellbeing works in partnership with contracted affiliates. Through your employer’s employee assistance program (EAP), Carelon Wellbeing provides counseling focused on short-term problem resolution. In the event your counselor determines you have a diagnosable mental health condition or substance use disorder, you will be referred to your medical benefit for treatment. Carelon Wellbeing does not provide psychiatry, in-patient or residential treatment hospitalization, intensive outpatient treatment, emergent care, long-term care, prescription medication, autism spectrum disorder treatment, services for remedial education or non-evidence based behavioral health care.',
  links: [
    // {
    //   url: `sitemap`,
    //   label: `Sitemap`,
    // },
    {
      url: 'privacy',
      label: 'Privacy Policy',
    },
    {
      url: 'notice',
      label: 'Notice of Privacy Practices',
    },
    {
      url: 'terms',
      label: 'Terms of Use',
    },
    {
      url: 'statement',
      label: 'Statement of Understanding',
    },
  ],
};



// WEBPACK FOOTER //
// ./client/models/global/Footer.js